import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_URL } from '../config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = async (userData, token) => {
    try {
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      return true;
    } catch (error) {
      console.error('Ошибка при сохранении данных:', error);
      return false;
    }
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  // Глобальная проверка сеанса для всех авторизованных пользователей
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const validateSession = () => {
      fetch(`${API_URL}/api/session`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` }
      }).catch(err => console.error('Session validation error:', err));
    };

    // Проверяем сеанс каждые 30 секунд
    const sessionInterval = setInterval(validateSession, 30000);

    // Первая проверка сразу при открытии сайта
    validateSession();

    return () => clearInterval(sessionInterval);
  }, [isAuthenticated]);

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth должен использоваться внутри AuthProvider');
  }
  return context;
};
